import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cwx-icon cwx-icon-before_warning-default"
}

import { ref } from 'vue';
import { TextBox as KTextBox } from '@progress/kendo-vue-inputs';


export default /*@__PURE__*/_defineComponent({
  __name: 'TextBox',
  props: /*@__PURE__*/_mergeModels({
    valid: { type: Boolean, default: true },
    width: { default: undefined },
    showClearButton: { type: Boolean, default: true }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {

const model = _useModel<string | number | undefined>(__props, "modelValue");

const props = __props;

const kTextBoxRef = ref<InstanceType<typeof KTextBox> | null>(null);

function handleChange() { }

__expose({
  focus: () => kTextBoxRef.value?.focus?.(),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(KTextBox), _mergeProps({
    ref_key: "kTextBoxRef",
    ref: kTextBoxRef
  }, _ctx.$attrs, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    "wrapper-class": !__props.valid ? 'k-invalid' : undefined,
    style: { width: props.width },
    valid: __props.valid,
    "show-clear-button": __props.showClearButton,
    "input-suffix": __props.valid ? undefined : 'suffix',
    onInput: handleChange
  }), _createSlots({
    suffix: _withCtx(() => [
      (!__props.valid)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    _renderList(_ctx.$slots, (_, name) => {
      return {
        name: name,
        fn: _withCtx((slotProps) => [
          _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotProps)))
        ])
      }
    })
  ]), 1040, ["modelValue", "wrapper-class", "style", "valid", "show-clear-button", "input-suffix"]))
}
}

})